import * as React from 'react';
import { Space, Form, Row, Col, Input } from 'antd';
import { Card, Button, DisplayInput } from '@comps'
import { Http, Message } from '@utils'

/**
 * 发票红冲
 */
const Item = Form.Item
const layout = {
    labelCol: { span: 12 },
    wrapperCol: { span: 12 },
};

export interface Props {
    onCancel: () => void,
    onConfirm: () => void,
    invoice?: JSONObject,
}

const InvoiceCancel: React.FC<Props> = ({
    onCancel, onConfirm, invoice = {},
}) => {
    const [form] = Form.useForm();
    form.setFieldsValue(invoice)

    const requestNo = invoice.requestNo
    const specialInvoice: boolean = invoice.specialInvoice

    async function handleSave() {
        await form.validateFields()
        let data = { ...form.getFieldsValue(), requestNo: requestNo }
        await Http.post(`/tax/outputInvoices/redInvoice`, data);
        Message.success('红冲成功')
        onConfirm();
    }

    return (
        <Card title='您确认要红冲发票吗？' style={{ marginBottom: '0' }}>
            <Form {...layout} form={form} name="red" initialValues={{}}>
                <Row>
                    <Col span={11} ><Item label="发票代码：" name='invoiceCode'><DisplayInput /></Item></Col>
                    <Col span={11} offset={1}><Item label="发票号码：" name='invoiceNo'><DisplayInput /></Item></Col>
                </Row>
                <Row>
                    <Col span={11} ><Item label="发票金额：" name='totalAmount'><DisplayInput /></Item></Col>
                    <Col span={11} offset={1}><Item label="开票日期：" name='invoiceDate'><DisplayInput /></Item></Col>
                </Row>
                <Row>
                    <Col span={24} >
                        <Item labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} label="通知单号：" name='redNoticeNo'
                            rules={[{ required: specialInvoice }]}><Input /></Item>
                    </Col>
                </Row>

                <Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                    <Space>
                        <Button type="primary" clickCallback={handleSave}>确认红冲</Button>
                        <Button onClick={onCancel}>取消</Button>
                    </Space>
                </Item>
            </Form>
        </Card>
    );
};

export default InvoiceCancel;
